module.exports = __webpack_public_path__ + "static/media/jp.f19ae754.svg";